import { useEffect, useState } from "react";
import { Button, Input, Modal, Form, Select, notification } from "antd";
import { useGetLocationsQuery } from "../../redux/services/locationsApi";
import {
  useAddLocationsToPartnerMutation
} from "../../redux/services/partnerApi";
import ErrorDetails from "../../components/ErrorDetails";

const { Option } = Select;

const AddLocationInPartnerModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { isModalOpen, partner, onCancel, refetch } = props;

  useEffect(() => {
    if (partner) {
      form.setFieldValue("partner_id", partner?.id);
      form.setFieldValue("name", partner?.name);
    }

    return () => {
      form.resetFields();
    };
  });

  const [api, contextHolder] = notification.useNotification();

  const [addLocationsToPartner] = useAddLocationsToPartnerMutation();

  const { data, error, isLoading } = useGetLocationsQuery({ all_pages: true });
  const locations: any = data?.locations || [];

  const onAddLocationToPartner = async (values: object, setLoading: any, id: any) => {
    try {
      setLoading(true);
      await addLocationsToPartner({ id, location: values }).unwrap();
      api.success({
        message: "Add location to partner operation successful",
        placement: "top"
      });
      setLoading(false);
      refetch();
      onCancel();
    } catch (error: any) {
      api.info({
        message: "Add location to partner operation failed",
        description: <ErrorDetails errors={error?.data || []} />,
        placement: "top"
      });
      setLoading(false);
    }
  };

  const onFinish = (values: any) => {
    onAddLocationToPartner({ location: values }, setLoading, partner?.id);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal title="Add Location" open={isModalOpen} onCancel={onCancel} footer={false}>
      {contextHolder}
      <Form
        name="location_partner_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="name" label="Partner Name">
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="location_id"
          label="Location"
          rules={[{ required: true, message: "Please select location" }]}
        >
          <Select
            placeholder="Select location"
            allowClear
            showSearch
            mode="multiple"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {locations
              ?.filter((loc: any) => loc.location_type === "city")
              ?.filter((loc: any) => loc.status === "active")
              ?.map((loc: any) => (
                <Option key={loc.name} value={loc.id}>
                  {loc.name}
                </Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button type="default" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Add
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddLocationInPartnerModal;
